import { Component } from '@angular/core';
import { TestimonialHelperService } from 'src/app/components/helper/testimonial-helper.service';

@Component({
  selector: 'app-testimonials',
  templateUrl: './testimonials.component.html',
  styleUrls: ['./testimonials.component.css']
})
export class TestimonialsComponent extends TestimonialHelperService {
  settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: true,
    customPaging: function () {
      return '<div class="sigma_round-dot dot-dark">' +
        '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 197 197" enable-background="new 0 0 197 197" xml:space="preserve">' +
        '<circle class="sigma_round-dot-stroke" stroke-linecap="round" cx="98.5" cy="98.6" r="97.5"></circle>' +
        '<circle class="sigma_round-dot-circle" stroke-linecap="round" cx="98.5" cy="98.6" r="97.5"></circle>' +
        '</svg>' +
        '</div>';
    }
  }
}
